import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Row, Button } from "react-bootstrap";
import SimpleContext from "../context/SimpleContext";
import "./ChatWithAdmin.css";
import config from "../../services/config.json";
import right from "../img/right.png";
import { useHistory } from "react-router";
import useLocalStorageState from "use-local-storage-state";
import { browserName, browserVersion } from "react-device-detect";
const ChatWithAdmin = () => {
  const [Tozihat, setTozihat] = useState("");
  const [Chat, setChat] = useLocalStorageState("Chat", false);
  const history = useHistory();
  const context = useContext(SimpleContext);
  const bgColor = context.theme.backgroundColor;
  const color = context.theme.color;
  const border = context.theme.border;
  const ChatSendBTN = {
    width: "20%",
    height: "40px",
    textAlign: "center",
    color: "#fff",
    backgroundColor: "#ff7014",
    border: "none",
    borderRadius: "12px",
  };
  const ChatSendBTNDis = {
    width: "20%",
    height: "40px",
    textAlign: "center",
    color: "color",
    backgroundColor: "gray",
    border: "none",
    borderRadius: "12px",
  };

  //برگشت از صفحه
  const goback = () => {
    history.go(-1);
  };
  //وب سرویس برای نمایش چت های کاربر
  useEffect(() => {
    let MyTime = Date.now();
    let TimeHeader = context.Encriptor(MyTime + context.timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    async function FinalPost() {
      const formData = new FormData();
      formData.append("userMobile", context.UseInFo.mobile);
      formData.append(
        "customerId",
        Object.values(context.UseInFo).length > 0 && context.UseInFo.customerId
      );
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", context.UniqueUUID);
      formData.append("appTypeId", context.AppType);
      const url = `${context.baseUrlApiPakhsh}${config.supportShowChat}`;
      const param = {
        method: "Post",
        body: formData,
        headers: myheaders,
      };
      const sendRequestSabt = await fetch(url, param);
      const responseSabt = await sendRequestSabt.json();
      return responseSabt;
    }
    try {
      FinalPost().then((data) => {
        if (data.popUp !== null) {
          if (data.popUp.text === "" && data.popUp.imageLink === "") {
            window.open(data.popUp.link, "noopener,noreferrer");
          } else {
            context.setmodalPopUp(true);
            context.setTextPopUp(data.popUp);
          }
        } else {
          context.setmodalPopUp(false);
        }
        if (parseInt(data.code) === 200) {
          context.setshowChat(data.response);
        } else if (parseInt(data.code) === 401) {
          context.setshowModalTime(true);
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  }, []);

  const messagesEndRef = useRef(null);
  //ارسال پیام توسط مشتری
  const handlesendMessage = () => {
    context.showChat.push({
      text: Tozihat,
      senderType: "customer",
    });
    context.setshowChat(context.showChat);
    let MyTime = Date.now();
    let TimeHeader = context.Encriptor(context.timeMiliSecondDef + MyTime);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    setTozihat("");
    axios
      .post(
        `${context.baseUrlApiPakhsh}${config.supportCreateMessage}`,
        {
          text: Tozihat,
          userName: context.UseInFo.customerName,
          customerId:
            Object.values(context.UseInFo).length > 0 &&
            context.UseInFo.customerId,
          userId:
            Object.values(context.UseInFo).length > 0 &&
            context.UseInFo.customerId,
          appVersion: browserName,
          AndroidVersion: browserVersion,
          deviceId: context.UniqueUUID,
          appTypeId: context.AppType,
        },
        { headers: myheaders }
      )
      .then((res) => {
        if (parseInt(res.data.code) === 200) {
          if (res.data.popUp !== null) {
            if (res.data.popUp.text === "" && res.data.popUp.imageLink === "") {
              window.open(res.data.popUp.link, "noopener,noreferrer");
            } else {
              context.setmodalPopUp(true);
              context.setTextPopUp(res.data.popUp);
            }
          } else {
            context.setmodalPopUp(false);
          }
          let MyTime = Date.now();
          let TimeHeader = context.Encriptor(
            MyTime + context.timeMiliSecondDef
          );
          const myheaders = {
            "atu-token": TimeHeader,
          };
          async function FinalPost() {
            const formData = new FormData();
            formData.append(
              "userMobile",
              context.UserPhone.length === 0 ? 0 : context.UserPhone
            );
            formData.append("senderType", "customer");
            formData.append(
              "addressID",
              context.UserPhone.length === 0 ||
                context.MyDefaultAddress === undefined
                ? 0
                : context.MyDefaultAddress.addressId
            );
            formData.append(
              "customerId",
              Object.values(context.UseInFo).length > 0 &&
                context.UseInFo.customerId
            );
            formData.append("appVersion", browserName);
            formData.append("AndroidVersion", browserVersion);
            formData.append("basketType", context.AppType);
            formData.append("deviceId", context.UniqueUUID);
            const url = `${context.baseUrlApiPakhsh}${config.showChat}`;
            const param = {
              method: "Post",
              body: formData,
              headers: myheaders,
            };
            const sendRequestSabt = await fetch(url, param);
            const responseSabt = await sendRequestSabt.json();
            return responseSabt;
          }
          try {
            FinalPost().then((data) => {
              if (parseInt(data.code) === 200) {
                context.setshowChat(data.response);
              } else if (parseInt(data.code) === 401) {
                context.setshowModalTime(true);
              }
            });
          } catch (ex) {
            console.log(ex);
          }
        } else if (parseInt(res.data.code) === 401) {
          context.setshowModalTime(true);
        }
      });
  };

  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <div style={{ width: "100%" }} className="MainMyApi">
        <div className="otherPagesHeader">
          <div className="barbuttonn">
            <img
              onClick={() => history.go(-1)}
              className="backIcon"
              src={right}
            />
          </div>
          <div className="headersNames">
            <p style={{ margin: "0" }}>گفت و گو با پشتیبانی</p>
          </div>
          <div style={{ width: "20%", visibility: "hidden" }}>
            <p style={{ marginTop: "3%", fontSize: "13px" }}>hide text</p>
          </div>
        </div>

        <div
          className="chatTexts"
          style={{
            backgroundImage: "url(" + "/images/ChatBackGround.jpg" + ")",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            position: "relative",
            overflowY: "auto",
            marginTop: "60px",
            height: "95vh",
          }}
        >
          {context.showChat.length > 0 ? (
            context.showChat.map((i, j) => (
              <>
                {i.senderType === "customer" ? (
                  <div className="msgHolder">
                    <div className="UserMsgs">
                      {/* <div className="miniImagesPlace"> */}
                      <div className="miniImages">
                        <div
                          className="userImagePlace"
                          style={{
                            backgroundImage:
                              context.UseInFo !== null
                                ? context.UseInFo.image !== ""
                                  ? "url(" + `${context.UseInFo.image}` + ")"
                                  : "url(" +
                                    "/images/placeholder_profile.jpg" +
                                    ")"
                                : null,
                            backgroundPosition: "center",
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                            position: "relative",
                            borderRadius: "50%",
                          }}
                        ></div>
                      </div>
                      {/* </div> */}
                      <p
                        style={{
                          margin: "0",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        {i.text}
                      </p>
                    </div>
                  </div>
                ) : (
                  <>
                    {i.senderType === "server" ? (
                      <div className="msgHolder">
                        <div className="ServerMsgs">
                          <p
                            style={{
                              margin: "0",
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            {i.text}
                          </p>
                          {/* <div className="miniImagesPlace"> */}
                          <div className="miniImages">
                            <img
                              alt="آیکون چت"
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "50%",
                              }}
                              src="/images/White.png"
                            />
                          </div>
                          {/* </div> */}
                        </div>
                      </div>
                    ) : null}
                  </>
                )}
              </>
            ))
          ) : (
            <p style={{ margin: "auto", fontWeight: "bold", color: "gray" }}>
              تاکنون گفت و گویی نداشته اید !
            </p>
          )}
          <div ref={messagesEndRef} />
        </div>

        <div className="chatInputText">
          <input
            value={Tozihat}
            className="inputTextChat"
            type="textarea"
            placeholder="پیام را تایپ کنید"
            onChange={(e) => {
              setTozihat(e.target.value);
            }}
          />
          {context.backsub === true ? (
            <button style={ChatSendBTNDis}>...</button>
          ) : (
            <button style={ChatSendBTN} onClick={() => handlesendMessage()}>
              ارسال
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatWithAdmin;
